module.exports = __webpack_public_path__ + "151cd9a1727298cc33c5296af8b53404.png";